module.exports = __webpack_public_path__ + "static/img/02.f0b1cc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/04-companyInfo/02.jpg
// module id = uyJ8
// module chunks = 1